export default "__VITE_ASSET__CU4GnAfV__"